"use client";
import { ChevronDown, ChevronUp } from "lucide-react";
import { useState } from "react";

interface ProductDescriptionProps {
    html: string;
}

const ProductDescription = ({ html }: ProductDescriptionProps) => {
    const [showMore, setShowMore] = useState(false);

    return (
        <div className="w-full p-1">
            <div className="flex items-center w-full my-4">
                <div
                    className="flex-grow h-[1px]"
                    style={{ backgroundColor: "#000" }}
                />
                <span className="mx-4 whitespace-nowrap text-sm">
                    نقد و بررسی
                </span>
                <div
                    className="flex-grow h-[1px] "
                    style={{ backgroundColor: "#000" }}
                />
            </div>
            <div
                className={`transition-all force-prose prose prose-p:text-gray-800 prose-h2:font-bold prose-h3:font-semibold prose-a:text-blue-700 mb-8 prose-img:rounded-xl duration-300 overflow-hidden ${showMore ? "max-h-full" : "max-h-[500px]"
                    } md:max-h-full`}
                dangerouslySetInnerHTML={{ __html: html }}
            />

            <div className="text-center mt-4 md:hidden">
                <button
                    onClick={() => setShowMore(!showMore)}
                    className="text-blue-600 hover:text-blue-800 text-sm flex items-center justify-center gap-1"
                >
                    {showMore ? "بستن" : "مشاهده بیشتر"}
                    {showMore ? <ChevronUp size={16} /> : <ChevronDown size={16} />}
                </button>
            </div>
        </div>
    );
};

export default ProductDescription;
